import html2canvas from "html2canvas";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatDateTime } from "./Date";
import { Grid } from "@material-ui/core";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import html2pdf from "html2pdf.js";
import { IoMdDownload } from "react-icons/io";

const VipInvitation = ({ event, download, view, modalCloseRef, eventData, isReferralCode }) => {
  const ref = React.useRef(null);
  const [showPasss, setShowPass] = useState(false);
  const [showQrButtons, setShowQrButtons] = React.useState(false);
  const submitButtonRef = useRef(null);
  const [qr, setQr] = useState("");
  console.log(event);
  const GenerateQRCode = () => {
    QRCode.toDataURL(
      event?.data?.referralLink,
      {
        width: 240,
        margin: 1,
      },
      (err, url) => {
        if (err) return console.error(err);
        setQr(url);
      }
    );
  };

  useEffect(() => {
    GenerateQRCode();
  }, [event]);

  const containerStyle = {
    maxWidth: "380px",
    backgroundColor: "#f4f4f4",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const eventDetails = {
    "6743219da2c442c836d4a7fe": {
      date: "शुक्रवार ७ नोव्हेंबर २०२५",
      image: "/0.png",
      name: "हमारे राम",
      download: "07_Nov_Gate_pass.pdf",
    },
    "67432233a2c442c836d4a800": {
      date: "शनिवार ८ नोव्हेंबर २०२५",
      image: "/1.png",
      name: "विशाल मिश्रा",
      download: "08_Nov_Gate_pass.pdf",
    },
    "6743224ea2c442c836d4a802": {
      date: "रविवार ९ नोव्हेंबर २०२५",
      image: "/2.png",
      name: "इन्स्ट्रुमेंटल फ्यूजन",
      download: "09_Nov_Gate_pass.pdf",
    },
    "67432266a2c442c836d4a804": {
      date: "सोमवार १० नोव्हेंबर २०२५",
      image: "/3.png",
      name: "श्री राष्ट्रसंत तुकोडोजी खंजिर भजन संध्या",
      download: "10_Nov_Gate_pass.pdf",
    },
    "67432288a2c442c836d4a806": {
      date: "मंगळवार ११ नोव्हेंबर २०२५",
      image: "/4.png",
      name: "हास्य यात्रा",
      download: "11_Nov_Gate_pass.pdf",
    },
    "674322b2a2c442c836d4a808": {
      date: "बुधवार १२ नोव्हेंबर २०२५",
      image: "/5.png",
      name: "अखिल सचदेवा",
      download: "12_Nov_Gate_pass.pdf",
    },
    "674322d4a2c442c836d4a80a": {
      date: "गुरुवार १३ नोव्हेंबर २०२५",
      image: "/6.png",
      name: "संस्कार भारती",
      download: "13_Nov_Gate_pass.pdf",
    },
    "674322f2a2c442c836d4a80c": {
      date: "शुक्रवार १४ नोव्हेंबर २०२५",
      image: "/7.png",
      name: "रेक्खा भारद्वाज आणि विशाल भारद्वाज",
      download: "14_Nov_Gate_pass.pdf",
    },
    "67432311a2c442c836d4a80e": {
      date: "शनिवार १५ नोव्हेंबर २०२५",
      image: "/8.png",
      name: "कविसम्मेलन",
      download: "15_Nov_Gate_pass.pdf",
    },
    "67432332a2c442c836d4a810": {
      date: "रविवार १६ नोव्हेंबर २०२५",
      image: "/9.png",
      name: "श्रेय्या घोषाल",
      download: "16_Nov_Gate_pass.pdf",
    },
    "68f0d2ff1a06085b483d9046": {
      date: "रविवार १७ नोव्हेंबर २०२५",
      image: "/10.png",
      name: "शंकर महादेवन",
      download: "17_Nov_Gate_pass.pdf",
    },
    "68f0d8321a06085b483d904b": {
      date: "रविवार १८ नोव्हेंबर २०२५",
      image: "/11.png",
      name: "अजय-अतुल",
      download: "18_Nov_Gate_pass.pdf",
    },
  };

  const selectedEventDetails = eventDetails[event?.data?.attendance[0]?.eventId] || {};

  const handleDownload = () => {
    const element = ref.current;
    if (!element) {
      console.error("Ref is null");
      return;
    }

    const aspectRatio = element.offsetHeight / element.offsetWidth;
    const pdfHeight = Math.ceil(380 * aspectRatio);

    const options = {
      margin: 0,
      filename: isReferralCode ? "VIP_Referral_Pass.pdf" : selectedEventDetails.download,
      image: { type: "png", quality: 1 },
      html2canvas: {
        scale: 2,
        width: 380,
        height: pdfHeight,
        useCORS: true,
      },
      jsPDF: {
        unit: "px",
        format: [380, pdfHeight],
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(element).save();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDownload();
    }, 2000);

    return () => clearTimeout(timer);
  }, [event]);

  const handleViewClick = () => {
    setShowPass(true);
    setTimeout(() => {
      submitButtonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);
  };

  // ✅ REFERRAL CODE PASS STYLES
  const boxLeftStyleReferral = {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "380px",
    boxSizing: "border-box",
  };

  const boxLeftStyle = {
    background: event?.data?.gate
      ? "radial-gradient(circle at center, rgba(255, 255, 255, 0.3) 0%, transparent 50%),linear-gradient(90deg, #2A5D87, #004AAD, #002A52)"
      : (event?.data?.passColor || eventData?.passColor || "linear-gradient(180deg, #3e1d0a, #ff147a)"),
    display: "flex",
    flexDirection: "column",
    position: "relative",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "380px",
    boxSizing: "border-box",
  };

  const headerStyle = {
    fontFamily: "'Arya', sans-serif",
    color: "white",
    fontSize: "clamp(30px, 4vw, 35px)",
    textAlign: "center",
    fontWeight: "bold",
    marginTop: "20px",
    lineHeight: "0.8",
    alignItems: "center",
  };

  const detailsStyle = {
    borderRadius: "6px",
    padding: "10px",
    textAlign: "center",
    fontSize: "clamp(14px, 3vw, 20px)",
    lineHeight: "1.6",
    fontWeight: "bolder",
    color: "#1d348c",
  };

  const textJubinStyle = {
    fontFamily: "'Arya', sans-serif",
    fontSize: "clamp(30px, 5vw, 40px)",
    fontWeight: "900",
    textAlign: "center",
    color: "#F0F0F0",
    marginTop: "2vh",
    background: "transparent",
  };

  const imageStyle = {
    position: "absolute",
    top: "10px",
    right: "4px",
    width: "80px",
    height: "auto",
    borderRadius: "8px",
  };

  const logoStyle = {
    position: "absolute",
    top: "10px",
    left: "2px",
    width: "80px",
    height: "auto",
  };

  const guestNameStyle = {
    fontFamily: "'Arial', sans-serif",
    fontSize: "16px",
    color: "black",
    fontWeight: "normal",
    marginLeft: "10px",
    marginTop: "1vh",
  };

  const qrCodeContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    borderBottom: "2px dotted #ddd",
  };

  const cardStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    backgroundColor: isReferralCode
      ? "#9333ea" // Purple for referral
      : (event?.data?.passColor || eventData?.passColor) || (
        event?.data?.gate === 3
          ? "#015aa9"
          : event?.data?.gate === 4
            ? "#ed048c"
            : "#72043f"),
    borderRadius: "10px",
    padding: "10px 15px",
    border: "2px solid #f3f3f3",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    width: "280px",
    minHeight: "110px",
    overflow: "hidden",
    boxSizing: "border-box",
    color: "white",
    flexWrap: "wrap",
  };

  const mainContainerStyle = {
    padding: "10px",
    borderRadius: "15px",
    display: "inline-block",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
  };

  const largeTextStyle1 = {
    fontSize: "60px",
    fontWeight: "bold",
    color: "white",
    transform: "scaleY(1.8)",
  };

  const sideTextStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    marginLeft: "10px",
    flex: 1,
    wordWrap: "break-word",
  };

  const headerTextStyle = {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "1.2",
  };

  const whiteBackgroundStyle = {
    backgroundColor: "white",
    margin: "10px 0",
    padding: "10px 0",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };

  // ✅ RENDER REFERRAL PASS
  if (isReferralCode) {
    return (
      <>
        <div className="button-container">
          <button
            ref={modalCloseRef}
            onClick={() => {
              setShowPass(true);
              handleDownload();
            }}
            className="btn-view"
          >
            <IoMdDownload />
            {download}
          </button>
        </div>

        <style jsx>{`
          .button-container {
            display: flex;
            justify-content: center;
            gap: 15px;
            margin: 20px;
          }

          .btn-view {
            padding: 12px 20px;
            font-size: 20px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            transition: background-color 0.3s ease, transform 0.2s ease-in-out;
            font-weight: 600;
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #9333ea, #7e22ce);
            color: white;
          }

          .btn-view:hover {
            background: linear-gradient(135deg, #a855f7, #9333ea);
            transform: scale(1.05);
          }
        `}</style>

        <div style={containerStyle}>
          <div style={boxLeftStyleReferral} ref={ref}>
            <div>
              <div style={headerStyle}>
                <span style={{ margin: 0, padding: 0 }}>VIP पास</span>
                <br />
                <span
                  style={{
                    color: "#fbbf24",
                    fontSize: "20px",
                    margin: 0,
                    padding: 0,
                    lineHeight: "1",
                  }}
                >
                  विशेष निमंत्रण
                </span>
              </div>

              <div style={{ ...textJubinStyle, color: "#fbbf24", fontSize: "28px" }}>
                {selectedEventDetails.name || "सर्व कार्यक्रमांसाठी"}
              </div>

              <img
                src="/image.png"
                alt="khasdar"
                style={{ ...logoStyle, filter: "brightness(1.2)" }}
                crossOrigin="anonymous"
              />

              <div style={whiteBackgroundStyle}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={guestNameStyle}>
                    <span>श्री./सौ. {event?.data?.firstName}</span>
                    <br />
                    <span>मोबाईल क्र. {event?.data?.mobileNumber}</span>
                  </div>
                </div>

                <div style={detailsStyle}>
                  <span
                    style={{
                      color: "#9333ea",
                      fontSize: "clamp(18px, 4vw, 24px)",
                      fontWeight: "bold",
                    }}
                  >
                    {selectedEventDetails.date || "७ नोव्हेंबर ते १८ नोव्हेंबर २०२५"}
                  {/* {selectedEventDetails.date}   */}
                    <br />
                    सायं.६ वाजता
                  </span>

                  <div style={qrCodeContainerStyle}>
                    <img src={qr} crossOrigin="anonymous" />
                  </div>
                </div>
              </div>

              <div style={mainContainerStyle}>
                <div style={cardStyle}>
                  <span style={largeTextStyle1}>5A</span>
                  <div style={sideTextStyle}>
                    <span style={headerTextStyle}>
                       प्रवेशद्वार<br />
                      सोमवारी पेठेच्या बाजूने
                    </span>
                    <span
                      style={{
                        fontSize: "12px",
                        lineHeight: "1.0",
                        marginTop: "4px",
                        color: "white",
                      }}
                    >
                      स्थळ: ईश्वर देशमुख शारीरिक शिक्षण महाविद्यालय, क्रीडा चौक,
                      हनुमान नगर, नागपूर.
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  paddingBottom: "10px",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "normal",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  Powered By
                  <img
                    src="/bharatOnline.png"
                    alt="bharatOnline"
                    crossOrigin="anonymous"
                    style={{
                      marginRight: "8px",
                      height: "25px",
                      marginLeft: "6px",
                    }}
                  />
                  Bharat Online
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  // ✅ REGULAR PASS (ORIGINAL CODE)
  return (
    <>
      <div className="button-container">
        <button
          ref={modalCloseRef}
          onClick={() => {
            setShowPass(true);
            handleDownload();
          }}
          className="btn-view"
        >
          <IoMdDownload />
          {download}
        </button>
      </div>

      <style jsx>{`
        .button-container {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin: 20px;
        }

        .btn-download,
        .btn-view,
        .btn-views {
          padding: 12px 20px;
          font-size: 20px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: background-color 0.3s ease, transform 0.2s ease-in-out;
          font-weight: 600;
          width: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-view {
          background: linear-gradient(135deg, #4c6ef5, #2a4f9c);
          color: white;
          position: relative;
        }

        .btn-view:hover {
          background: linear-gradient(135deg, #7da4c3, #a3c7e1);
          transform: scale(1.05);
        }
      `}</style>

      <div style={containerStyle}>
        <div style={boxLeftStyle} ref={ref}>
          <div>
            <div style={headerStyle}>
              <span style={{ margin: 0, padding: 0 }}>प्रवेशिका</span>
              <br />
              <span
                style={{
                  color: "white",
                  fontSize: "20px",
                  margin: 0,
                  padding: 0,
                  lineHeight: "1",
                }}
              >
                निमंत्रित
              </span>
            </div>
            <div style={textJubinStyle}>
              {selectedEventDetails.name}
            </div>
            <img
              src={selectedEventDetails.image}
              alt="Image"
              style={imageStyle}
              crossOrigin="anonymous"
            />

            <img
              src="/image.png"
              alt="khasdar"
              style={logoStyle}
              crossOrigin="anonymous"
            />

            <div style={whiteBackgroundStyle}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={guestNameStyle}>
                  <span>श्री./सौ. {event?.data?.firstName}</span>
                  <br />
                  <span>मोबाईल क्र. {event?.data?.mobileNumber}</span>
                </div>
              </div>

              <div style={detailsStyle}>
                <span
                  style={{
                    color: "black",
                    fontSize: "clamp(20px, 4vw, 28px)",
                    fontWeight: "bold",
                  }}
                >
                  {selectedEventDetails.date || "तारीख उपलब्ध नाही"} सायं.६ वाजता
                </span>

                <div style={qrCodeContainerStyle}>
                  <img src={qr} crossOrigin="anonymous" />
                </div>
              </div>
            </div>

            <div style={mainContainerStyle}>
              <div style={cardStyle}>
                <span style={largeTextStyle1}>
                  {event?.data?.gate ? event?.data?.gate : "3"}
                </span>
                <div style={sideTextStyle}>
                  <span style={headerTextStyle}>
                    <>
                      {event?.data?.gate === 3 ? (
                        <>
                          प्रवेशद्वार साउथ पॉइंट स्कूल समोर <br /> हनुमान नगर
                        </>
                      ) : event?.data?.gate === 4 ? (
                        <>प्रवेशद्वार आयुर्वेदिक कॉलेज, रेशिमबाग</>
                      ) : (
                        <>
                          प्रवेशद्वार साउथ पॉइंट स्कूल समोर <br /> हनुमान नगर
                        </>
                      )}
                    </>
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      lineHeight: "1.0",
                      marginTop: "4px",
                      color: "white",
                    }}
                  >
                    स्थळ: ईश्वर देशमुख शारीरिक शिक्षण महाविद्यालय, क्रीडा चौक,
                    हनुमान नगर, नागपूर.
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <span
                style={{
                  color: "white",
                  fontWeight: "normal",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Powered By
                <img
                  src="/bharatOnline.png"
                  alt="bharatOnline"
                  crossOrigin="anonymous"
                  style={{
                    marginRight: "8px",
                    height: "25px",
                    marginLeft: "6px",
                  }}
                />
                Bharat Online
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VipInvitation;